//#region imports
import { Globals } from './../../../../services/globals';
import { TranslateService } from '@ngx-translate/core';
import { MatDatepickerInputEvent } from '@angular/material';
import { FormGroup, FormControl } from '@angular/forms';
import { SaveAddressModel } from './../../model/signature.model';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { SignatureService } from 'src/app/services/signature.service';
import { NotificationService } from 'src/app/services/notification.service';
import { SectionService } from 'src/app/services/section.service';
// import * as moment from 'moment';
import { GuaranteeService } from 'src/app/services/guarantee.service';
import * as moment from 'moment';
//#endregion

@Component({
  selector: 'app-signature-question1',
  templateUrl: './signature-question1.component.html',
  styleUrls: ['./signature-question1.component.css']
})
export class SignatureQuestion1Component implements OnInit, OnDestroy {
  //#region variables
  minDate: Date;
  maxDate: Date;
  date: any;
  saveAddress: SaveAddressModel;
  signatureSaveList: SaveAddressModel;
  userStatus: any;
  signatureData: any;
  id: any;
  selectedPremium: any;
  premiumFrequency: any = [];
  contract = false;
  signForm = new FormGroup({
    date: new FormControl(this.date)
  });
  enableCancellationButton = false;
  isCustomer = false;
  totalPremium: any;
  //#endregion

  //#region methods
  constructor(
    private translate: TranslateService, private global: Globals, private signatureService: SignatureService,
    private notification: NotificationService, private sectionService: SectionService, private guaranteeService: GuaranteeService) {
    const currentYear = new Date().getFullYear();
    this.minDate = new Date(currentYear, new Date().getMonth(), new Date().getDate() + 1);
    this.maxDate = new Date(currentYear + 1, 11, 31);
  }

  ngOnInit() {
    this.sectionService.setCurrentPage('P5-1');
    this.global.trackPageActivity += ';' + 'P5-1';
    this.totalPremium = +((this.global.totalPremium).replace(',', '.'));
    this.signatureData = JSON.parse(sessionStorage.getItem('signatureData'));
    const premiumFrequency1 = this.translate.instant('Tab_Frequency_Payment1');
    const premiumFrequency2 = this.translate.instant('Tab_Frequency_Payment2');
    const premiumFrequency3 = this.translate.instant('Tab_Frequency_Payment3');
    const premiumSplitFrequency1 = this.translate.instant('Tab_Frequency_SplitPayment1');
    const premiumSplitFrequency2 = this.translate.instant('Tab_Frequency_SplitPayment2');
    const premiumSplitFrequency3 = this.translate.instant('Tab_Frequency_SplitPayment3');
    
    this.premiumFrequency = [{Frequency :premiumFrequency1, Percentage : ' ' }, {Frequency :premiumFrequency2, Percentage : premiumSplitFrequency2 }, 
      {Frequency :premiumFrequency3, Percentage : premiumSplitFrequency3 }];

    this.global.paymentFrequency = this.premiumFrequency;
    this.selectedPremium = this.signatureData.Premium_Frequency_paiement != null &&
      this.signatureData.Premium_Frequency_paiement !== '' ? this.signatureData.Premium_Frequency_paiement : premiumFrequency1;
    if(this.premiumFrequency.findIndex(f=>f.Frequency == this.signatureData.Premium_Frequency_paiement) == -1)
     this.selectedPremium = this.signatureService.premiumFreqencyIndex?
        this.premiumFrequency[this.signatureService.premiumFreqencyIndex] : premiumFrequency1;
        this.signatureService.premiumFreqencyIndex = this.premiumFrequency.findIndex(f=>f.Frequency==this.selectedPremium)
      this.mapAnswer('Premium_Frequency_paiement', this.selectedPremium);
    this.global.paymentFrequencyanswer = this.selectedPremium;
    this.setData();
    this.isCustomer = this.global.isClient;
  }

  onChange(newValue) {
    this.signatureService.premiumFreqencyIndex = this.premiumFrequency.findIndex(f=>f.Frequency ==newValue)
    // console.log(newValue);
    this.selectedPremium = newValue;
    this.mapAnswer('Premium_Frequency_paiement', this.selectedPremium);
    this.global.paymentFrequencyanswer = this.selectedPremium;
  }

  setData() {
    this.contract = this.signatureData.Contract_other_company != null &&
      this.signatureData.Contract_other_company !== '' ? this.signatureData.Contract_other_company : false;
    this.date = this.signatureData.Contract_start_date;
    if (this.date != null && this.date !== '') {
      this.signForm.get('date').patchValue(new Date(this.date));
    } 
    // else
    // {
    //   const mindateVal = moment(new Date(this.minDate)).format('YYYY-MM-DD');
    //   this.date = mindateVal;
    //   this.signForm.get('date').patchValue(new Date(mindateVal));
    //   this.mapAnswer('Contract_start_date', mindateVal);
    // }
  }

  selectedAnswer(choice, event) {
    this.mapAnswer(choice, event.target.checked);
    this.enableCancellationButton = event.target.checked ? true : false;
  }

  addEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    const dateVal = moment(new Date(event.value)).format('YYYY-MM-DD');
    this.signForm.get('date').patchValue(new Date(event.value));
    this.mapAnswer('Contract_start_date', dateVal);
  }

  downloadCancellationTemplate() {
    this.signatureService.getCancellationTemplateLocation().subscribe((data) => {
      const link = document.createElement('a');
      const docname = data.substring(data.lastIndexOf('/') + 1);
      link.download = docname;
      link.href = data;
      link.click();
      // window.open(data, '_blank'); twice document downloading so commeting this line.
    });
  }

  mapAnswer(selectedChoice, selectedText) {
    const jsonData = sessionStorage.getItem('signatureData');
    const data = JSON.parse(jsonData);
    //const saveAddress = new SaveAddressModel();
    const saveAddress = this.signatureService.getSaveAddress1();
    switch (selectedChoice) {
      case 'Contract_other_company':
        data.Contract_other_company = selectedText;
        saveAddress.Contract_other_company = selectedText;
        break;
      case 'Contract_start_date':
        data.Contract_start_date = selectedText;
        saveAddress.Contract_start_date = selectedText;
        break;
      case 'Premium_Frequency_paiement':
        data.Premium_Frequency_paiement = selectedText;
        saveAddress.Premium_Frequency_paiement = selectedText;
        break;
    }
    this.signatureService.setSaveAddress1(saveAddress);
    sessionStorage.setItem('signatureData', JSON.stringify(data));
  }

  test() {
    // console.log(this.date);
  }

  ngOnDestroy() {
    if (this.id) {
      clearInterval(this.id);
    }
  }
  helpDialog(value: string) {
    value = this.translate.instant(value);
    this.notification.openDialog(value);
  }
  //#endregion
}
